// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1YjB1","buttons":"SendReceipts_buttons__1DKkh","email":"SendReceipts_email__PBRBW","bookApptTitle":"SendReceipts_bookApptTitle__UcKaT"};